import { BookOpen } from "lucide-react";
import { useLocale, useTranslations } from "use-intl";

import { Button } from "@lawline/ui/components/button";
import { ExternalLink } from "@platform/components/ui/external-link";
import { docsLink } from "@platform/core/docs";

// The documentation is a site of its own, so it opens in a new tab and the portal stays open.
export function DocsLink({ labelClassName }: { labelClassName: string }) {
	const tNav = useTranslations("common.nav");
	const locale = useLocale();
	return (
		<Button asChild variant="ghost" size="sm" className="h-9 w-full justify-start gap-3 text-xs">
			<ExternalLink
				href={docsLink("home", locale)}
				cueClassName={`text-muted-foreground -ml-2 ${labelClassName}`}
			>
				<BookOpen className="text-muted-foreground size-4 shrink-0" />
				<span className={labelClassName}>{tNav("items.docs")}</span>
			</ExternalLink>
		</Button>
	);
}
